// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map from "../Data.Map/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_NamedParams from "../Data.NamedParams/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Record_Extra2 from "../Data.Record.Extra2/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Vault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_Form_Delayed from "../Restaumatic.Form.Delayed/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_Errors from "../Restaumatic.Form.Errors/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_FormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic_Form_HasDefaultValue from "../Restaumatic.Form.HasDefaultValue/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic_Form_Result from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic_Form_Totality from "../Restaumatic.Form.Totality/index.js";
import * as Restaumatic_Form_WithExtra from "../Restaumatic.Form.WithExtra/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Extra from "../Specular.FRP.Extra/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_FRP_List from "../Specular.FRP.List/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unsafe_Reference from "../Unsafe.Reference/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Base.bindDynamic);
var apply = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Base.applyDynamic);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var $$for = /* #__PURE__ */ Data_Traversable["for"](Specular_FRP_Base.applicativeDynamic)(Data_Traversable.traversableArray);
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Form_Query.eqStrictness);
var pure = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_Result.applicativeResult);
var map1 = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_Result.functorResult);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var append = /* #__PURE__ */ Data_Semigroup.append(Restaumatic_Form_Errors.semigroupFormErrors);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(Restaumatic_Form_Result.applicativeResult);
var map2 = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_DynamicResult.functorDynamicResult);
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Host.bindHost);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var discard1 = /* #__PURE__ */ discard(Specular_FRP_Host.bindHost);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_FRP_Host.monadEffectHost);
var pure3 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var read = /* #__PURE__ */ Specular_Ref.read(Effect_Class.monadEffectEffect);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect.applicativeEffect)(Data_Map_Internal.foldableMap);
var map3 = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_Delayed.functorDelayed);
var readDelayed = /* #__PURE__ */ Restaumatic_Form_Delayed.readDelayed(Effect_Class.monadEffectEffect);
var append2 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var pure4 = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_Delayed.applicativeDelayed);
var map4 = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var for1 = /* #__PURE__ */ Data_Traversable["for"](Effect.applicativeEffect)(Data_Traversable.traversableArray);
var unless = /* #__PURE__ */ Control_Applicative.unless(Effect.applicativeEffect);
var modify = /* #__PURE__ */ Specular_Ref.modify(Effect_Class.monadEffectEffect);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var merge = /* #__PURE__ */ Restaumatic_Form_Internal.merge(/* #__PURE__ */ Restaumatic_Form_FormField["mergeFormField$prime"](Type_Equality.refl));
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_Set.foldableSet);
var makeImpl = /* #__PURE__ */ Restaumatic_Form_Internal.makeImpl(/* #__PURE__ */ Restaumatic_Form_FormField.initializeRecordFormField(/* #__PURE__ */ Data_NamedParams.fromDefaults1()())(Restaumatic_Form_Totality.isTotalityTotal)()(/* #__PURE__ */ Restaumatic_Form_FormField.initialValueTotalNoInitia(Restaumatic_Form_HasDefaultValue.hasDefaultValueArray))(/* #__PURE__ */ Restaumatic_Form_FormField.metadataValueMetadata()(Type_Equality.refl)));
var pure5 = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_DynamicResult.applicativeDynamicResult);
var queryLaxWithDefault = /* #__PURE__ */ Restaumatic_Form_Query.queryLaxWithDefault(/* #__PURE__ */ Restaumatic_Form_FormField["queryFormField$prime"](Type_Equality.refl));
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray);
var $$new = /* #__PURE__ */ Specular_Ref["new"](Specular_FRP_Host.monadEffectHost);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(Data_Vault.monoidVault);
var fixDelayed = /* #__PURE__ */ Restaumatic_Form_Delayed.fixDelayed(Specular_FRP_Host.monadEffectHost);
var subscribeDyn_ = /* #__PURE__ */ Specular_FRP_Base.subscribeDyn_(/* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost));
var recordEncode = /* #__PURE__ */ Foreign_Generic_Class.recordEncode();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var itemsIsSymbol = {
    reflectSymbol: function () {
        return "items";
    }
};
var encodeRecordCons2 = /* #__PURE__ */ encodeRecordCons1(itemsIsSymbol);
var subformIsSymbol = {
    reflectSymbol: function () {
        return "subform";
    }
};
var keyIsSymbol = {
    reflectSymbol: function () {
        return "key";
    }
};
var encodeRecordCons3 = /* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(subformIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.foreignEncode)))(keyIsSymbol);
var sequenceRecord = /* #__PURE__ */ Record_Extra.sequenceRecord();
var sequenceRecord1 = /* #__PURE__ */ sequenceRecord(/* #__PURE__ */ Record_Extra.sequenceRecordSingle(itemsIsSymbol)()(Specular_FRP_Base.functorDynamic)()());
var fromFoldable1 = /* #__PURE__ */ Data_Array.fromFoldable(Data_Map_Internal.foldableMap);
var sequenceRecord2 = /* #__PURE__ */ sequenceRecord(/* #__PURE__ */ Record_Extra.sequenceRecordCons(keyIsSymbol)()(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Record_Extra.sequenceRecordSingle(subformIsSymbol)()(Specular_FRP_Base.functorDynamic)()())()());
var modify1 = /* #__PURE__ */ Restaumatic_Form_FormField.modify(Restaumatic_Form_FormField["formFieldLikeFormField$prime"]);
var bind3 = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var append3 = /* #__PURE__ */ Data_Semigroup.append(Data_Vault.semigroupVault);
var readRef = /* #__PURE__ */ Specular_Ref.readRef(Effect_Class.monadEffectEffect);
var Item = function (x) {
    return x;
};
var Mapping = function (x) {
    return x;
};
var DelayedItem = function (x) {
    return x;
};
var queryItem = function (dictQuery) {
    var queryImpl = Restaumatic_Form_Query.queryImpl(dictQuery);
    return {
        queryImpl: function (s) {
            return function (v) {
                return queryImpl(s)(v.subform);
            };
        }
    };
};
var queryArrayTupleMapping = function (dictOrd) {
    var lookup = Data_Map_Internal.lookup(dictOrd);
    return function (dictQuery) {
        var queryImpl = Restaumatic_Form_Query.queryImpl(dictQuery);
        return {
            queryImpl: function (s) {
                return function (v) {
                    return Restaumatic_Form_DynamicResult.annotated("query Mapping")(Restaumatic_Form_DynamicResult.wrap(bind(apply(map(function (v1) {
                        return function (v2) {
                            return {
                                items: v1,
                                keys_: v2
                            };
                        };
                    })(Specular_Ref.value(v.items)))(v.keys))(function (v1) {
                        var entryResults = $$for(v1.keys_)(function (k) {
                            var v2 = lookup(k)(v1.items);
                            if (v2 instanceof Data_Maybe.Just) {
                                return apply(map(function (v3) {
                                    return function (v4) {
                                        var handleInvalid = function (result) {
                                            var $379 = eq(s)(Restaumatic_Form_Query.Lax.value);
                                            if ($379) {
                                                return Restaumatic_Form_Result.orElse(result)(Data_Maybe.Nothing.value);
                                            };
                                            return result;
                                        };
                                        if (!v3) {
                                            return pure(Data_Maybe.Nothing.value);
                                        };
                                        if (v3) {
                                            return handleInvalid(map1((function () {
                                                var $454 = Data_Tuple.Tuple.create(k);
                                                return function ($455) {
                                                    return Data_Maybe.Just.create($454($455));
                                                };
                                            })())(v4));
                                        };
                                        throw new Error("Failed pattern match at Restaumatic.Form.Mapping (line 326, column 15 - line 330, column 69): " + [ v3.constructor.name ]);
                                    };
                                })(v.presentWhen(v2.value0)))(Restaumatic_Form_DynamicResult.unwrap(queryImpl(s)(v2.value0.subform)));
                            };
                            if (v2 instanceof Data_Maybe.Nothing) {
                                return pure1(Restaumatic_Form_Result.mapErrors(function (v3) {
                                    return append(v3)(Restaumatic_Form_Errors.internalError("Mapping key not found"));
                                })(pure(Data_Maybe.Nothing.value)));
                            };
                            throw new Error("Failed pattern match at Restaumatic.Form.Mapping (line 314, column 9 - line 333, column 99): " + [ v2.constructor.name ]);
                        });
                        return map((function () {
                            var $456 = map1(Data_Array.catMaybes);
                            return function ($457) {
                                return $456(sequence($457));
                            };
                        })())(entryResults);
                    })));
                };
            }
        };
    };
};
var queryMapMapping = function (dictOrd) {
    var fromFoldable2 = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
    var queryArrayTupleMapping1 = queryArrayTupleMapping(dictOrd);
    return function (dictQuery) {
        var queryImpl = Restaumatic_Form_Query.queryImpl(queryArrayTupleMapping1(dictQuery));
        return {
            queryImpl: function (s) {
                return function (field) {
                    return map2(fromFoldable2)(queryImpl(s)(field));
                };
            }
        };
    };
};
var querySerializedMapMapping = function (dictOrd) {
    var queryMapMapping1 = queryMapMapping(dictOrd);
    return function (dictQuery) {
        var queryImpl = Restaumatic_Form_Query.queryImpl(queryMapMapping1(dictQuery));
        return {
            queryImpl: function (s) {
                var $458 = map2(wrap);
                var $459 = queryImpl(s);
                return function ($460) {
                    return $458($459($460));
                };
            }
        };
    };
};
var mappingLikeMapping = {
    withMappingD: function (f) {
        return f;
    }
};
var itemLikeItem = {
    key: function (v) {
        return v.key;
    },
    subform: function (v) {
        return v.subform;
    },
    toItemE: pure2
};
var initializeSomeInitializer = {
    makeImpl: Restaumatic_Form_Internal.makeWithSomeInitializer
};
var initializeSomeInitialValu = function (dictInitialize) {
    var makeImpl1 = Restaumatic_Form_Internal.makeImpl(dictInitialize);
    return function (dictMerge) {
        var merge1 = Restaumatic_Form_Internal.merge(dictMerge);
        return {
            makeImpl: function (p) {
                return function (opts) {
                    return function (meta) {
                        return function (v) {
                            return function (initializer) {
                                return bind1(makeImpl1(p)(opts)(meta)(Restaumatic_Form_Internal.NoInitialValue.value)(initializer))(function (field) {
                                    return discard1(liftEffect(merge1(v.value0)(field)))(function () {
                                        return pure3(field);
                                    });
                                });
                            };
                        };
                    };
                };
            }
        };
    };
};
var initializeNoInitializerMa = function (dictInitialize) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithDefaultInitializer(dictInitialize)({
            item: function (v) {
                return Restaumatic_Form_Internal.NoInitializer.value;
            }
        })
    };
};
var initializeMetadataInitial = function (dictMakeWithMetadataInitializer) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithMetadataInitializer(dictMakeWithMetadataInitializer)
    };
};
var initializeInitialValueIni = function (dictMakeWithInitialValueInitializer) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithInitialValueInitializer(dictMakeWithInitialValueInitializer)
    };
};
var hasFieldIdMapping = {
    getFieldId: function (v) {
        return Restaumatic_Form_Internal.fieldPathToString(v.name);
    }
};
var getFieldId = /* #__PURE__ */ Restaumatic_Form_Internal.getFieldId(hasFieldIdMapping);
var hasFieldIdItem = function (dictShow) {
    var show = Data_Show.show(dictShow);
    return {
        getFieldId: function (v) {
            return getFieldId(v.parent) + ("." + show(v.key));
        }
    };
};
var hasFieldIdDelayedItem = function (dictShow) {
    var show = Data_Show.show(dictShow);
    return {
        getFieldId: function (v) {
            return v.parentId + ("." + show(v.key));
        }
    };
};
var withMappingD = function (dict) {
    return dict.withMappingD;
};
var mappingLikeDelayed = function (dictMappingLike) {
    var withMappingD1 = withMappingD(dictMappingLike);
    return {
        withMappingD: function (f) {
            return function (v) {
                return bind(v)(withMappingD1(f));
            };
        }
    };
};
var mappingLikeWithExtra = function (dictMappingLike) {
    var withMappingD1 = withMappingD(dictMappingLike);
    return {
        withMappingD: function (f) {
            var $461 = withMappingD1(f);
            return function ($462) {
                return $461(Restaumatic_Form_WithExtra.subform($462));
            };
        }
    };
};
var unwrapDelayedItem = function (v) {
    return v.item;
};
var toMappingE = function (dictMappingLike) {
    var $463 = withMappingD(dictMappingLike)(pure1);
    return function ($464) {
        return readDynamic($463($464));
    };
};
var toItemE = function (dict) {
    return dict.toItemE;
};
var subform = function (dict) {
    return dict.subform;
};
var subform1 = /* #__PURE__ */ subform(itemLikeItem);
var addErrorsMapping = function (dictAddErrors) {
    var addErrors = Restaumatic_Form_Internal.addErrors(dictAddErrors);
    return {
        addErrors: function (errors) {
            return function (v) {
                return function __do() {
                    var items = read(v.items)();
                    return for_(items)(function (item) {
                        return addErrors(errors)(subform1(item));
                    })();
                };
            };
        }
    };
};
var hasErrorsItem = function (dictHasErrors) {
    var displayedErrors = Restaumatic_Form_Internal.displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (f) {
            return displayedErrors(subform1(f));
        }
    };
};
var hasLabelItem = function (dictHasLabel) {
    var getLabel = Restaumatic_Form_Internal.getLabel(dictHasLabel);
    return {
        getLabel: function (f) {
            return getLabel(subform1(f));
        }
    };
};
var isSelectFieldItem = function (dictIsSelectField) {
    var selectWriteValue = Restaumatic_Form_Internal.selectWriteValue(dictIsSelectField);
    var selectReadValue = Restaumatic_Form_Internal.selectReadValue(dictIsSelectField);
    var selectGetOptions = Restaumatic_Form_Internal.selectGetOptions(dictIsSelectField);
    var selectTouch = Restaumatic_Form_Internal.selectTouch(dictIsSelectField);
    return {
        selectWriteValue: function (f) {
            return selectWriteValue(subform1(f));
        },
        selectReadValue: function (f) {
            return selectReadValue(subform1(f));
        },
        selectGetOptions: function (f) {
            return selectGetOptions(subform1(f));
        },
        selectTouch: function (f) {
            return selectTouch(subform1(f));
        }
    };
};
var itemLikeDelayedDelayedIte = {
    key: function (v) {
        return v.key;
    },
    subform: function (v) {
        return map3(subform1)(v.item);
    },
    toItemE: function (v) {
        return readDelayed(v.item);
    }
};
var subform2 = /* #__PURE__ */ subform(itemLikeDelayedDelayedIte);
var hasErrorsDelayedItem = function (dictHasErrors) {
    var displayedErrors = Restaumatic_Form_Internal.displayedErrors(Restaumatic_Form_Internal.hasErrorsDelayed(dictHasErrors));
    return {
        displayedErrors: function (f) {
            return displayedErrors(subform2(f));
        }
    };
};
var hasFieldDelayedDelayedIte = function (dictHasField) {
    var getField = Data_Record.getField(Restaumatic_Form_Delayed.hasFieldDelayedDelayed(dictHasField));
    return {
        getField: function (label) {
            var $465 = getField(label);
            return function ($466) {
                return $465(subform2($466));
            };
        }
    };
};
var mergeDelayedItem = function (dictMerge) {
    var merge1 = Restaumatic_Form_Internal.merge(Restaumatic_Form_Internal.mergeDelayed(dictMerge));
    return {
        merge: function (x) {
            var $467 = merge1(x);
            return function ($468) {
                return $467(subform2($468));
            };
        }
    };
};
var queryDelayedItem = function (dictQuery) {
    var queryImpl = Restaumatic_Form_Query.queryImpl(Restaumatic_Form_Query.queryDelayed(dictQuery));
    return {
        queryImpl: function (s) {
            var $469 = queryImpl(s);
            return function ($470) {
                return $469(subform2($470));
            };
        }
    };
};
var readLabel = function (dictMappingLike) {
    return withMappingD(dictMappingLike)(function (v) {
        return Restaumatic_Form_Final.unFinal(v.label);
    });
};
var newtypeMapping = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeItem = {
    Coercible0: function () {
        return undefined;
    }
};
var mergeItem = function (dictMerge) {
    var merge1 = Restaumatic_Form_Internal.merge(dictMerge);
    return {
        merge: function (x) {
            return function (v) {
                return merge1(x)(v.subform);
            };
        }
    };
};
var makeItem = function (dictShow) {
    var show = Data_Show.show(dictShow);
    return function (dictAddContext) {
        var addContext = Restaumatic_Form_Internal.addContext(dictAddContext);
        return function (v) {
            return function (key2) {
                return function __do() {
                    var v1 = Specular_FRP_Host.runHost(v.init(v)({
                        name: append2(v.name)([ show(key2) ])
                    })(key2))();
                    var ctx = Effect_Ref.read(v.context)();
                    addContext(ctx)(v1.value0.subform)();
                    return {
                        parent: v1.value0.parent,
                        key: v1.value0.key,
                        subform: v1.value0.subform,
                        cleanup: v1.value1
                    };
                };
            };
        };
    };
};
var key = function (dict) {
    return dict.key;
};
var key1 = /* #__PURE__ */ key(itemLikeItem);
var toDelayedItem = function (item) {
    return {
        key: key1(item),
        parentId: getFieldId((unwrap(item)).parent),
        item: pure4(item)
    };
};
var itemForKey = function (dictOrd) {
    var lookup = Data_Map_Internal.lookup(dictOrd);
    return function (dictMappingLike) {
        var withMappingD1 = withMappingD(dictMappingLike);
        return function (df) {
            return function (k) {
                return Data_Function.flip(withMappingD1)(df)(function (v) {
                    return map(lookup(k))(Specular_Ref.value(v.items));
                });
            };
        };
    };
};
var hasFieldItem = function (dictHasField) {
    var getField = Data_Record.getField(dictHasField);
    return {
        getField: function (label) {
            return function (v) {
                return getField(label)(v.subform);
            };
        }
    };
};
var eqItem = {
    eq: Unsafe_Reference.unsafeRefEq
};
var eqMaybe = /* #__PURE__ */ Data_Maybe.eqMaybe(eqItem);
var eqArray = /* #__PURE__ */ Data_Eq.eqArray(eqItem);
var ensureItems = function (dictOrd) {
    var lookup = Data_Map_Internal.lookup(dictOrd);
    var insert = Data_Map_Internal.insert(dictOrd);
    return function (dictShow) {
        var makeItem1 = makeItem(dictShow);
        return function (dictAddContext) {
            var makeItem2 = makeItem1(dictAddContext);
            return function (v) {
                return function (keys) {
                    return function __do() {
                        var items$prime = read(v.items)();
                        var newItems = map4(Data_Array.catMaybes)(for1(keys)(function (v1) {
                            return function __do() {
                                var v2 = (function () {
                                    var v2 = lookup(v1.value0)(items$prime);
                                    if (v2 instanceof Data_Maybe.Just) {
                                        return new Data_Tuple.Tuple(v2.value0, Data_Maybe.Nothing.value);
                                    };
                                    if (v2 instanceof Data_Maybe.Nothing) {
                                        var item = makeItem2(v)(v1.value0)();
                                        return new Data_Tuple.Tuple(item, new Data_Maybe.Just(new Data_Tuple.Tuple(v1.value0, item)));
                                    };
                                    throw new Error("Failed pattern match at Restaumatic.Form.Mapping (line 268, column 27 - line 273, column 50): " + [ v2.constructor.name ]);
                                })();
                                v1.value1(v2.value0)();
                                return v2.value1;
                            };
                        }))();
                        return unless(Data_Array["null"](newItems))(modify(v.items)(function (oldItems) {
                            return foldl(function (m) {
                                return function (v1) {
                                    return insert(v1.value0)(v1.value1)(m);
                                };
                            })(oldItems)(newItems);
                        }))();
                    };
                };
            };
        };
    };
};
var mergeMapMapping = function (dictOrd) {
    var ensureItems1 = ensureItems(dictOrd);
    return function (dictShow) {
        var ensureItems2 = ensureItems1(dictShow);
        return function (dictMerge) {
            var merge1 = Restaumatic_Form_Internal.merge(mergeItem(dictMerge));
            return function (dictAddContext) {
                var ensureItems3 = ensureItems2(dictAddContext);
                return {
                    merge: function (m) {
                        return function (v) {
                            return function __do() {
                                ensureItems3(v)(mapFlipped(toUnfoldable(m))(function (v1) {
                                    return new Data_Tuple.Tuple(v1.value0, merge1(v1.value1));
                                }))();
                                return merge(fromFoldable(Data_Map.keys(m)))(v.editableKeys)();
                            };
                        };
                    }
                };
            };
        };
    };
};
var mergeSMapMapping = function (dictOrd) {
    var mergeMapMapping1 = mergeMapMapping(dictOrd);
    return function (dictShow) {
        var mergeMapMapping2 = mergeMapMapping1(dictShow);
        return function (dictMerge) {
            var mergeMapMapping3 = mergeMapMapping2(dictMerge);
            return function (dictAddContext) {
                var merge1 = Restaumatic_Form_Internal.merge(mergeMapMapping3(dictAddContext));
                return {
                    merge: function (m) {
                        return function (ff) {
                            return merge1(unwrap(m))(ff);
                        };
                    }
                };
            };
        };
    };
};
var initializeNoInitialValueR = function (dictAddContext) {
    return function (dictOrd) {
        var ensureItems1 = ensureItems(dictOrd);
        return function (dictShow) {
            var ensureItems2 = ensureItems1(dictShow)(dictAddContext);
            return function (dictInitialize) {
                var makeImpl1 = Restaumatic_Form_Internal.makeImpl(dictInitialize);
                return function (dictFromDefaults) {
                    var fromDefaults = Data_NamedParams.fromDefaults(dictFromDefaults);
                    return function (dictMaybeGet) {
                        var maybeGet = Data_Record_Extra2.maybeGet(dictMaybeGet);
                        return function (dictMaybeGetMetadata) {
                            var maybeGetMetadata = Restaumatic_Form_Internal.maybeGetMetadata(dictMaybeGetMetadata);
                            return function (dictMaybeGetMetadata1) {
                                var maybeGetMetadata1 = Restaumatic_Form_Internal.maybeGetMetadata(dictMaybeGetMetadata1);
                                return function (dictMetadataValue) {
                                    var getMetadataValue = Restaumatic_Form_FormField.getMetadataValue(dictMetadataValue);
                                    return {
                                        makeImpl: function (p) {
                                            return function (opts) {
                                                return function (meta) {
                                                    return function (v) {
                                                        return function (initializer) {
                                                            return bind1(makeImpl(Type_Proxy["Proxy"].value)({
                                                                name: append2(opts.name)([ "keys" ])
                                                            })(getMetadataValue(maybeGetMetadata1(meta)))(Restaumatic_Form_Internal.NoInitialValue.value)({
                                                                options: Data_Maybe.fromMaybe(pure5([  ]))(maybeGet(initializer))
                                                            }))(function (editableKeys_) {
                                                                var params = fromDefaults({
                                                                    keys: queryLaxWithDefault(mempty)(editableKeys_),
                                                                    keyOptions: pure5([  ]),
                                                                    presentWhen: function (v1) {
                                                                        return pure1(true);
                                                                    },
                                                                    label: pure5("")
                                                                })(initializer);
                                                                return bind1($$new(Data_Map_Internal.empty))(function (items) {
                                                                    return bind1(liftEffect(Effect_Ref["new"](mempty1)))(function (context) {
                                                                        var presentWhen_ = function ($471) {
                                                                            return params.presentWhen(toDelayedItem($471));
                                                                        };
                                                                        var init = function (parent) {
                                                                            return function (itemOpts) {
                                                                                return function (key2) {
                                                                                    return fixDelayed(function (item) {
                                                                                        var ditem = {
                                                                                            key: key2,
                                                                                            parentId: getFieldId(parent),
                                                                                            item: item
                                                                                        };
                                                                                        return bind1(makeImpl1(p)(itemOpts)(maybeGetMetadata(meta))(Restaumatic_Form_Internal.NoInitialValue.value)(params.item(ditem)))(function (subform3) {
                                                                                            return pure3({
                                                                                                parent: parent,
                                                                                                key: key2,
                                                                                                subform: subform3,
                                                                                                cleanup: pure2(Data_Unit.unit)
                                                                                            });
                                                                                        });
                                                                                    });
                                                                                };
                                                                            };
                                                                        };
                                                                        var m = {
                                                                            name: opts.name,
                                                                            items: items,
                                                                            init: init,
                                                                            context: context,
                                                                            editableKeys: editableKeys_,
                                                                            keys: params.keys,
                                                                            presentWhen: presentWhen_,
                                                                            label: params.label
                                                                        };
                                                                        return discard1(Restaumatic_Form_Delayed.afterInitialized(Data_Function.flip(subscribeDyn_)(params.keys)(function (ks) {
                                                                            return ensureItems2(m)(mapFlipped(ks)(function (k) {
                                                                                return new Data_Tuple.Tuple(k, function (v1) {
                                                                                    return pure2(Data_Unit.unit);
                                                                                });
                                                                            }));
                                                                        })))(function () {
                                                                            return pure3(m);
                                                                        });
                                                                    });
                                                                });
                                                            });
                                                        };
                                                    };
                                                };
                                            };
                                        }
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var editableKeys = function (v) {
    return v.editableKeys;
};
var dumpStateMapping = function (dictEncodeWithOptions) {
    var encode = Foreign_Generic_Class.encode(recordEncode(encodeRecordCons2(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(recordEncode(encodeRecordCons3(dictEncodeWithOptions)))))));
    return function (dictDumpState) {
        var dumpState = Restaumatic_Form_Internal.dumpState(dictDumpState);
        return {
            dumpState: function (v) {
                return bind(Specular_Ref.value(v.items))(function (items) {
                    return map(encode)(sequenceRecord1({
                        items: $$for(fromFoldable1(items))(function (v1) {
                            return sequenceRecord2({
                                key: pure1(v1.key),
                                subform: dumpState(v1.subform)
                            });
                        })
                    }));
                });
            }
        };
    };
};
var displayedItems = function (dictOrd) {
    var lookup = Data_Map_Internal.lookup(dictOrd);
    return function (dictMappingLike) {
        return withMappingD(dictMappingLike)(function (v) {
            return apply(map(function (v1) {
                return function (v2) {
                    return Data_Array.mapMaybe(function (k) {
                        return lookup(k)(v1);
                    })(v2);
                };
            })(Specular_Ref.value(v.items)))(v.keys);
        });
    };
};
var displayWithIndex = function (dictOrd) {
    var displayedItems1 = displayedItems(dictOrd);
    return function (dictMonadFRP) {
        var dynamicListWithIndex_ = Specular_FRP_List.dynamicListWithIndex_(dictMonadFRP);
        return function (dictMonadReplace) {
            var dynamicListWithIndex_1 = dynamicListWithIndex_(dictMonadReplace);
            var withDynamic_ = Specular_FRP_Replaceable.withDynamic_(dictMonadReplace)(dictMonadFRP);
            return function (dictMappingLike) {
                var displayedItems2 = displayedItems1(dictMappingLike);
                return function (l) {
                    return function (renderItem) {
                        return dynamicListWithIndex_1(displayedItems2(l))(function (ix) {
                            return function (ditem) {
                                return withDynamic_(ditem)(renderItem(pure1(ix)));
                            };
                        });
                    };
                };
            };
        };
    };
};
var displayKey = function (dictOrd) {
    var itemForKey1 = itemForKey(dictOrd);
    return function (dictMonadFRP) {
        var withUniqDynamic_ = Specular_FRP_Extra.withUniqDynamic_(dictMonadFRP);
        var traverse_ = Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Data_Foldable.foldableMaybe);
        return function (dictMonadReplace) {
            var withUniqDynamic_1 = withUniqDynamic_(dictMonadReplace)(eqMaybe);
            return function (dictMappingLike) {
                var itemForKey2 = itemForKey1(dictMappingLike);
                return function (ff) {
                    return function (k) {
                        return function (display1) {
                            return withUniqDynamic_1(itemForKey2(ff)(k))(traverse_(display1));
                        };
                    };
                };
            };
        };
    };
};
var display = function (dictOrd) {
    var displayedItems1 = displayedItems(dictOrd);
    return function (dictMonadFRP) {
        var withUniqDynamic_ = Specular_FRP_Extra.withUniqDynamic_(dictMonadFRP);
        var traverse_ = Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Data_Foldable.foldableArray);
        return function (dictMonadReplace) {
            var withUniqDynamic_1 = withUniqDynamic_(dictMonadReplace)(eqArray);
            return function (dictMappingLike) {
                var displayedItems2 = displayedItems1(dictMappingLike);
                return function (l) {
                    return function (renderItem) {
                        return withUniqDynamic_1(displayedItems2(l))(traverse_(renderItem));
                    };
                };
            };
        };
    };
};
var deleteItem = function (dictEq) {
    var eq1 = Data_Eq.eq(dictEq);
    return function (dictItemLike) {
        var toItemE1 = toItemE(dictItemLike);
        return function (ditem) {
            return function __do() {
                var v = toItemE1(ditem)();
                return modify1(v.parent.editableKeys)(function (a) {
                    return Data_Maybe.fromMaybe(a)(bind3(Data_Array.findIndex(eq1(v.key))(a))(function (index) {
                        return Data_Array.deleteAt(index)(a);
                    }));
                })();
            };
        };
    };
};
var addItem = function (dictAddContext) {
    return function (dictOrd) {
        var insert = Data_Map_Internal.insert(dictOrd);
        return function (dictShow) {
            var makeItem1 = makeItem(dictShow)(dictAddContext);
            return function (dictMappingLike) {
                var toMappingE1 = toMappingE(dictMappingLike);
                return function (df) {
                    return function (key2) {
                        return function __do() {
                            var v = toMappingE1(df)();
                            var item = makeItem1(v)(key2)();
                            modify(v.items)(insert(key2)(item))();
                            modify1(v.editableKeys)(function (v1) {
                                return append2(v1)([ key2 ]);
                            })();
                            return item;
                        };
                    };
                };
            };
        };
    };
};
var addContextMapping = function (dictAddContext) {
    var addContext = Restaumatic_Form_Internal.addContext(dictAddContext);
    return {
        addContext: function (ctx) {
            return function (v) {
                return function __do() {
                    Effect_Ref.modify_(function (v1) {
                        return append3(ctx)(v1);
                    })(v.context)();
                    var items = readRef(v.items)();
                    return for_(items)(function (item) {
                        return addContext(ctx)(subform1(item));
                    })();
                };
            };
        }
    };
};
export {
    key,
    subform,
    toItemE,
    withMappingD,
    Mapping,
    toMappingE,
    readLabel,
    Item,
    DelayedItem,
    toDelayedItem,
    unwrapDelayedItem,
    editableKeys,
    ensureItems,
    makeItem,
    itemForKey,
    displayKey,
    displayedItems,
    display,
    displayWithIndex,
    deleteItem,
    addItem,
    newtypeMapping,
    hasFieldIdMapping,
    mappingLikeMapping,
    mappingLikeWithExtra,
    mappingLikeDelayed,
    newtypeItem,
    hasFieldItem,
    queryItem,
    mergeItem,
    eqItem,
    isSelectFieldItem,
    hasLabelItem,
    hasErrorsItem,
    hasFieldIdItem,
    itemLikeItem,
    itemLikeDelayedDelayedIte,
    hasFieldDelayedDelayedIte,
    queryDelayedItem,
    mergeDelayedItem,
    hasErrorsDelayedItem,
    hasFieldIdDelayedItem,
    initializeNoInitialValueR,
    initializeInitialValueIni,
    initializeMetadataInitial,
    initializeNoInitializerMa,
    initializeSomeInitializer,
    initializeSomeInitialValu,
    mergeMapMapping,
    mergeSMapMapping,
    queryArrayTupleMapping,
    queryMapMapping,
    querySerializedMapMapping,
    addContextMapping,
    dumpStateMapping,
    addErrorsMapping
};
